import React from "react";
import { Box, Typography } from "@mui/material";
import { Instagram } from "@mui/icons-material";

const posts = [
  {
    id: 1,
    type: "image",
    src: "/instagram/post3.jpg",
    link: "https://www.instagram.com/p/DVTRWSHjAFg/?hl=en&img_index=1/",
  },
  {
    id: 2,
    type: "image",
    src: "/instagram/ing1.jpg",
    link: "https://www.instagram.com/p/DVxIAssjMqI/?hl=en&img_index=1/",
  },
  {
    id: 3,
    type: "video",
    src: "/instagram/post1.mp4",
    link: "https://www.instagram.com/p/DVaRQpmDJUD/?hl=en/",
  },
  {
    id: 4,
    type: "image",
    src: "/instagram/ing3.jpg",
    link: "https://www.instagram.com/p/DVBCLf1jKVB/?hl=en&img_index=1/",
  },
];

export default function InstagramSection() {
  return (
    <Box className="w-full bg-white py-12 px-1 md:px-4">

      {/* Heading */}
      <Box className="flex items-center justify-center gap-2 mb-10">
        <Instagram />
        <Typography variant="h6" className="font-semibold tracking-wider">
          FOLLOW US ON INSTAGRAM
        </Typography>
      </Box>

      {/* Grid */}
      <Box className="grid grid-cols-2 md:grid-cols-4 gap-3">

        {posts.map((post) => (
          <a
            key={post.id}
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="h-[280px] md:h-[360px] overflow-hidden relative group"
          >
            {post.type === "image" ? (
              <img
                src={post.src}
                alt="instagram"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            ) : (
              <video
                src={post.src}
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            )}

            {/* Hover Gradient */}
            <Box className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition duration-300 flex items-center justify-center">
              <Instagram
                className="opacity-0 group-hover:opacity-100 text-4xl transition duration-300"
                sx={{
                  background:
                    "radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              />
            </Box>

          </a>
        ))}

      </Box>
    </Box>
  );
}